import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    Ng2StateDeclaration,
    Transition,
    UIRouterModule
} from '@uirouter/angular';
import { CheckupRouteModule } from '../checkup/CheckupRoute';
import { CompanySettingRoute } from '../company-setting/CompanySettingRoute';
import { ExpensesRoutingModule } from '../expenses/expense-routing.module';
import { IndirectJobsRoute } from '../indirect-jobs/IndirectJobsRoute';
import { LoginComponent } from '../login/login.component';
import { MainComponent } from '../main/main.component';
import { routerConfigFn } from '../router.config';
import { ProcessDetailComponent, ProcessListComponent } from '../shared';
import { CategoriesService } from '../shared/category/categories.service';
import { CategoryDetailComponent } from '../shared/category/category-detail/category-detail.component';
import { CategoryListComponent } from '../shared/category/category-list/category-list.component';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ContractClassRoute } from './ContractClassRoute';
import { ContractCumulativeRoute } from './ContractCumulativeRoute';
import { ContractMgmtRoute } from './ContractMgmtRoute';
import { ContractStructureRoute } from './ContractStructureRoute';
import { ExpenseItemRoute } from './ExpenseItemRoute';
import { ViewExpenseReceiptRoute } from './ExpensesRoute';
import { FixedPriceRoute } from './FixedPriceRoute';
import { LogoRoute } from './LogoRoute';
import { OversignTimeRoute } from './OversignTimeRoute';
import { RolesGroupsRoutingModule } from './roles-groups-routing.module';
import { TimeCardRoutingModule } from './time-card-routing.module';
import { UserEntryDatesRoute } from './UserEntryDatesRoute';

// TODO: split these into areas

const log = new LoggingService();

const main: Ng2StateDeclaration = {
    name: 'main',
    data: { requiresAuth: true },
    url: '',
    component: MainComponent
};

const categoryList: Ng2StateDeclaration = {
    name: 'category',
    data: { requiresAuth: true },
    url: '/category',
    component: CategoryListComponent
};

const categoryDetail: Ng2StateDeclaration = {
    name: 'category.detail',
    data: { requiresAuth: true },
    url: '/:catId',
    component: CategoryDetailComponent,
    resolve: [
        {
            token: 'category',
            deps: [Transition, CategoriesService],
            resolveFn: categoryResolveFn
        }
    ]
};
export function categoryResolveFn(t, svc) {
    log.debug({
        type: 'category state resolveFn',
        catId: t.params().catId
    });
    return svc.getCategory(t.params().catId);
}

const processList: Ng2StateDeclaration = {
    name: 'category.detail.process',
    data: { requiresAuth: true },
    url: '/process',
    component: ProcessListComponent
};

const processDetail: Ng2StateDeclaration = {
    name: 'category.detail.process.detail',
    data: { requiresAuth: true },
    url: '/:procId',
    component: ProcessDetailComponent,
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolveFn
        }
    ]
};
export function processResolveFn(t, svc) {
    log.debug({
        type: 'process state resolveFn',
        catId: t.params().catId,
        procId: t.params().procId
    });
    return svc.getProcess(t.params().catId, t.params().procId);
}
const login: Ng2StateDeclaration = {
    name: 'login',
    url: '/login',
    component: LoginComponent
};

@NgModule({
    imports: [
        CommonModule,
        TimeCardRoutingModule,
        ExpensesRoutingModule,
        RolesGroupsRoutingModule,
        CheckupRouteModule,
        UIRouterModule.forRoot({
            // TODO: will having all these here mess with lazy loading of modules?
            // https://ui-router.github.io/guide/lazyloading
            states: [
                categoryList,
                categoryDetail,
                processList,
                processDetail,
                ExpenseItemRoute,
                ContractClassRoute,
                ViewExpenseReceiptRoute,
                FixedPriceRoute,
                UserEntryDatesRoute,
                ContractStructureRoute,
                ContractMgmtRoute,
                ContractCumulativeRoute,
                IndirectJobsRoute,
                CompanySettingRoute,
                LogoRoute,
                OversignTimeRoute,
                login,
                main
            ],
            useHash: false,
            config: routerConfigFn
        })
    ]
})
export class EfaactRoutingModule {}
